import { useState } from 'react';
import { Link } from 'react-router-dom';

interface HeaderProps {
  cartItemsCount: number;
}

export default function Header({ cartItemsCount }: HeaderProps) {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <header className="bg-gray-900 border-b border-gray-800">
      {/* Top Bar */}
      <div className="bg-purple-700 text-white py-2">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <span>🎮 Gaming Marketplace</span>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1">
              <i className="ri-global-line"></i>
              <span>English</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center">
              <i className="ri-gamepad-line text-white text-xl"></i>
            </div>
            <span className="text-white text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
              GameVault
            </span>
          </Link>

          {/* Search Bar */}
          <div className="flex-1 max-w-2xl mx-8">
            <div className="relative">
              <input
                type="text"
                placeholder="Search for games, gift cards and more"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full bg-gray-800 text-white px-4 py-3 pl-12 rounded-lg border border-gray-700 focus:border-purple-500 focus:outline-none text-sm"
              />
              <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
            </div>
          </div>

          {/* Right Actions */}
          <div className="flex items-center gap-4">
            <button className="text-gray-400 hover:text-white cursor-pointer">
              <i className="ri-heart-line text-xl"></i>
            </button>
            <Link to="/cart" className="relative text-gray-400 hover:text-white cursor-pointer">
              <i className="ri-shopping-cart-line text-xl"></i>
              {cartItemsCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-yellow-400 text-black text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                  {cartItemsCount}
                </span>
              )}
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
